import React, { useContext } from "react"

import { Row, Col } from "react-bootstrap"

import {
  PORTFOLIO_FORM_DELETE,
  EXPERIENCE_FORM_DELETE,
} from "../actions/professionalAction"
import {
  EDUCATION_FORM_DELETE,
  TRAINING_FORM_DELETE,
} from "../actions/educationAction"
import { SOCIAL_DELETE } from "../actions/socialAction"
import { COMPANY_SOCIAL_DELETE } from "../../company-profile/actions/socialAction"
import { DELETE_JOB } from "../../job/job-actions"
import { GlobalAuthContext } from "../../../context/authContext"

const DeleteConfirmForm = props => {
  const { state, dispatch } = useContext(GlobalAuthContext)
  const { id, setShowDeleteForm, type, isCompany, setData, data } = props
  const handleDeleteOK = async e => {
    if (!isCompany) {
      switch (type.toString()) {
        case "PORTFOLIO":
          PORTFOLIO_FORM_DELETE(id, setShowDeleteForm)
          break
        case "EXPERIENCE":
          EXPERIENCE_FORM_DELETE(id, setShowDeleteForm)
          break
        case "EDUCATION":
          EDUCATION_FORM_DELETE(id, setShowDeleteForm)
          break
        case "TRAINING":
          TRAINING_FORM_DELETE(id, setShowDeleteForm)
          break
        case "SOCIAL":
          SOCIAL_DELETE(id, setShowDeleteForm, setData, data)
          break
        default:
          return
      }
    } else {
      switch (type) {
        case "SOCIAL":
          COMPANY_SOCIAL_DELETE(id, setShowDeleteForm, setData, data)
          break
        case "JOB_POST":
          const res = await DELETE_JOB(id)
          if (res?.status === 204) {
            const filteredJobs = state?.job_posted_list?.results?.filter(
              job => job?.id !== data?.id
            )

            setData({ ...state?.job_posted_list, results: filteredJobs })
          }
          setShowDeleteForm(false)
        default:
          return
      }
    }
  }
  return (
    <>
      <h1>Confirm</h1>
      <p className="mb-4">
        Are you sure want to delete ? You cannot undo after deleting.
      </p>
      <Row>
        <Col>
          <button
            type="submit"
            className="btn w-100 btn-custom rounded btn-danger mb-2"
            value="  Save and continue"
            onClick={handleDeleteOK}
          >
            Ok
          </button>
        </Col>
      </Row>

      <Row>
        <Col>
          <button
            type="submit"
            className="btn w-100 btn-custom rounded primary"
            value="  Save and continue"
            onClick={() => setShowDeleteForm(false)}
          >
            Cancel
          </button>
        </Col>
      </Row>
    </>
  )
}

export default DeleteConfirmForm
